import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAppStore } from '../stores/useAppStore'

const PaymentSuccess = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { addNotification } = useAppStore()

    useEffect(() => {
        const sessionId = searchParams.get('id')

        if (sessionId) {
            // Mark payment as successful for the component to pick up
            sessionStorage.setItem('paymentSuccessCallback', 'true')

            addNotification({
                type: 'success',
                message: 'Payment completed successfully! Redirecting you back to the work order.',
                timestamp: Date.now()
            })

            // Redirect back to work orders list after a short delay
            setTimeout(() => {
                navigate('/workorders')
            }, 3000)
        } else {
            // No session ID, redirect to work orders
            navigate('/work-orders')
        }
    }, [searchParams, navigate, addNotification])


  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <div className="text-6xl mb-4">✅</div>
          <h1 className="text-2xl font-bold text-green-600 mb-2">Payment Successful!</h1>
          <p className="text-gray-600">
            Your payment has been processed successfully. You will be redirected to your work orders shortly.
          </p>
        </div>

        <div className="mb-6">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
          <p className="text-sm text-gray-500 mt-2">Redirecting...</p>
        </div>

        <button
          onClick={() => navigate('/work-orders')}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full"
        >
          Return to Work Orders
        </button>
      </div>
    </div>
  )
}

export default PaymentSuccess 